import { render, staticRenderFns } from "./CaixaForm.vue?vue&type=template&id=d39e70c6&scoped=true&"
import script from "./CaixaForm.vue?vue&type=script&lang=js&"
export * from "./CaixaForm.vue?vue&type=script&lang=js&"
import style0 from "./CaixaForm.vue?vue&type=style&index=0&id=d39e70c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39e70c6",
  null
  
)

export default component.exports